import StandAloneSlider from './stand-alone-slider';
export default StandAloneSlider;